// import ReactOnRails from 'react-on-rails'
import noop from 'lodash/noop'

if (typeof window === 'undefined') {
  global.window = { location: {} }
  global.fetch = noop
  window.scrollTo = noop
  window.matchMedia = () => ({
    matches: false,
    addListener: noop,
    removeListener: noop,
  })

  global.clearTimeout = noop
  global.setTimeout = noop
}

if (typeof navigator === 'undefined') {
  global.navigator = {}
}

if (typeof document === 'undefined') {
  global.document = {
    addEventListener: noop,
    querySelector: noop,
  }
}
